module.exports = __webpack_public_path__ + "img/logo.aefa05a5.png";